import { parseMeta } from './parse_meta';

const API_KEY = 'ac4051060a992146b04ad6c8a4f4ae3c';
const CURRENT_USER_KEY = 'current-user';

function userData() {
  const userMeta = parseMeta(CURRENT_USER_KEY);
  return userMeta && userMeta.user;
}

function userAttributes() {
  const userState = userData();

  return {
    email: userState.email,
    customerid: (userState.id && userState.id.toString()),
    other: userState.cookieId,
  };
}

function syncMparticleLogin() {
  if (!(userData().loggedOut || mparticleIsLoggedIn())) {
    window.mParticle.Identity.login({
      userIdentities: userAttributes(),
    });
  } else if (mparticleIsLoggedIn() && !userData().loggedOut) {
    const userIdentities = mparticleUserIdentity();
    const attributes = userAttributes();
    if (userIdentities.customerid !== attributes.clusterid ||
        userIdentities.email !== attributes.email) {
      window.mParticle.Identity.login({
        userIdentities: attributes,
      });
    }
  }
}

function mparticleSetCustomAttributes(result) {
  if (result.httpCode === 200 || result.httpCode === -3) {
    // httpCode of 200 indicates is a successful identity call
    // httpCode of -3 indicates there was an active session, so no identity call is made, but the callback is still triggered
    const user = result.getUser();
    const userState = userData();
    user.setUserAttribute('country', userState.countryCode);
    user.setUserAttribute('shippingRegionCode', userState.shippingRegionCode);
    user.setUserAttribute('locale', userState.locale);
    user.setUserAttribute('contextId', userState.cookieId);
    user.setUserAttribute('sessionId', userState.sessionId);
    syncMparticleLogin();
  }
}

function mparticleUserIdentity() {
  const mparticleUser = window.mParticle.Identity.getCurrentUser();
  return mparticleUser.getUserIdentities().userIdentities;
}

function mparticleIsLoggedIn() {
  const userIdentities = mparticleUserIdentity();
  return userIdentities.email || userIdentities.customerId;
}

export function mparticleIdentify() {
  // we do not want to create new users in mparticle for bots
  const { isBot } = userData();
  if (isBot) return;

  window.mParticle = {};
  window.mParticle.eCommerce = { Cart: {} };

  window.mParticle.Identity = {};
  window.mParticle.config = {
    isDevelopmentMode: MPARTICLE_DEVELOPMENT_MODE,
    identifyRequest: {
      userIdentities: userAttributes(),
    },
    identityCallback: mparticleSetCustomAttributes,
  };
  window.mParticle.config.rq = [];
  window.mParticle.ready = function (f) {
    window.mParticle.config.rq.push(f);
  };
  function a(o, t) { return function () { t && (o = `${t}.${o}`); const e = Array.prototype.slice.call(arguments); e.unshift(o), window.mParticle.config.rq.push(e); }; } let x = ['endSession', 'logError', 'logEvent', 'logForm', 'logLink', 'logPageView', 'setSessionAttribute', 'setAppName', 'setAppVersion', 'setOptOut', 'setPosition', 'startNewSession', 'startTrackingLocation', 'stopTrackingLocation'],
    y = ['setCurrencyCode', 'logCheckout'],
    z = ['login', 'logout', 'modify']; x.forEach((o) => { window.mParticle[o] = a(o); }), y.forEach((o) => { window.mParticle.eCommerce[o] = a(o, 'eCommerce'); }), z.forEach((o) => { window.mParticle.Identity[o] = a(o, 'Identity'); });

  const mp = document.createElement('script');
  mp.type = 'text/javascript';
  mp.async = true;
  mp.src = `${document.location.protocol == 'https:' ? 'https://jssdkcdns' : 'http://jssdkcdn'}.mparticle.com/js/v2/${API_KEY}/mparticle.js`;
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(mp, s);
}

$(() => {
  mparticleIdentify();
});



// WEBPACK FOOTER //
// ./javascripts/components/mparticle_identity.js